// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"45a7ac2132c5ce88a709c88f5c72ad39f43c47a9"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.0.7";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

export { captureRouterTransitionStart as onRouterTransitionStart } from "@sentry/nextjs";

Sentry.init({
  enabled: process.env.NODE_ENV === "production" && !!process.env.NEXT_PUBLIC_SENTRY_DSN,

  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT_NAME || "unknown",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  release: process.env.NEXT_PUBLIC_APP_RELEASE_NAME || undefined, // inject at build time
});

Sentry.setTags({
  git_commit: process.env.NEXT_PUBLIC_GIT_COMMIT_HASH,
  build_date: process.env.NEXT_PUBLIC_BUILD_DATE,
});
